export default __webpack_public_path__ + "static/media/google_drive.c7bf6ae1.png";